import { gql } from '@apollo/client';
export const ATTESTATION_FIELDS = gql `
  fragment AttestationFields on Attestation {
    id
    clientId
    attestableType
    attestableId
    contentId
    userId
    createdAt
    updatedAt
  }
`;
export const ATTESTATIONS = gql `
  ${ATTESTATION_FIELDS}
  query ATTESTATIONS($spec: AttestationSpec!) {
    attestations(spec: $spec) {
      ...AttestationFields
    }
  }
`;
